import React from 'react'
import { observer } from 'mobx-react'

import { IProps as ITableCellEditorParams } from './TableCellEditor'

import styles from './stringInput.scss'

interface IProps extends ITableCellEditorParams {
  initialValue: BigInt | null
}

interface IState {
  value: BigInt | null
}

class BigIntInput extends React.PureComponent<IProps, IState> {
  private input: React.RefObject<HTMLInputElement> = React.createRef()

  constructor(props: IProps) {
    super(props)

    const { initialValue } = props
    const value =
      initialValue === undefined || initialValue === null
        ? null
        : BigInt(initialValue)

    this.state = {
      value,
    }
  }

  // Called by ag-grid to get the final value when editing is finished
  getValue = () => BigInt(this.state.value)

  focus = () => {
    this.input.current?.focus()
  }

  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value

    if (value === '') {
      // When a BigInt field is emptied, we just set it to null
      this.setState({ value: null })
      return
    }

    try {
      const valueAsBigInt = BigInt(value)
      this.setState({ value: valueAsBigInt })
    } catch (e) {
      // do nothing if value is not parse-able as a BigInt
    }
  }

  render() {
    const { value } = this.state

    return (
      <input
        data-cy="input--bigint"
        ref={this.input}
        className={styles.input}
        type="string"
        value={value === null || value === undefined ? '' : value.toString()}
        placeholder="null"
        onChange={this.handleChange}
      />
    )
  }
}

export default observer(BigIntInput)
